import { ServicesContainer } from '@/services';
import { ViewBagEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, Commerce } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { ProductListItem } from '../classes';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeCartViewEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.ViewBag;
  commerce = { ... this.commerce, productListViews: { value: 1 } } as Commerce;

  constructor(event: ViewBagEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    if (event.meals) {
      this.productListItems = ProductListItem.getProductListItems(event.meals, store, services.order.isDelivery());
    }

    if(event.upsellItems) {
      this.productListItems = [...(this.productListItems || []), ...event.upsellItems];
      this.commerce.upsellImpression = { value: 1 };
    }
  }
}
